import { Scene } from 'phaser';
import { initLocalization, t } from '../i18n/Localization';

export class Credits extends Scene {
  constructor() {
    super('Credits');
  }

  create(): void {
    initLocalization(this);
    const { width, height } = this.scale;

    this.add.rectangle(width / 2, height / 2, width, height, 0x0d1f33, 1);

    this.add.text(width / 2, height * 0.18, t('credits.title'), {
      fontFamily: 'Crackvetica, Arial',
      fontSize: '56px',
      color: '#ffffff',
      stroke: '#000000',
      strokeThickness: 6,
    }).setOrigin(0.5);

    this.add.text(width / 2, height * 0.42, t('credits.team'), {
      fontFamily: 'Arial Black',
      fontSize: '28px',
      color: '#9fffd0',
    }).setOrigin(0.5);

    this.add.text(width / 2, height * 0.52, t('credits.thanks'), {
      fontFamily: 'Arial',
      fontSize: '24px',
      color: '#ffd48a',
    }).setOrigin(0.5);

    const back = this.add.text(width / 2, height * 0.84, t('ui.back'), {
      fontFamily: 'Arial Black',
      fontSize: '28px',
      color: '#ffffff',
    }).setOrigin(0.5);

    back.setInteractive({ useHandCursor: true });
    back.on('pointerover', () => back.setColor('#ffd34d'));
    back.on('pointerout', () => back.setColor('#ffffff'));
    back.on('pointerdown', () => this.scene.start('MainMenu'));
  }
}

